module.exports = __webpack_public_path__ + "img/icon_pin_on.dee934b1.svg";